import {DI} from '../types'
import {ContainerModule, ContainerModuleLoadOptions} from 'inversify'
import type {ProductListItemViewModelFactory} from '@/src/features/catalog/product-list/product-item-factory'
import {productViewModelFactory} from '@/src/features/catalog/product-list/product-item-factory'
import {
  CatalogProductListViewModelFactory,
  CatalogProductListVM,
} from '@/src/features/catalog/product-list/model'
import {Product} from '@/src/core/domain/entities/product'
import {FiltersViewModelFactory} from '@/src/features/catalog/filters-v2/view-model/filters.view-model.interface'
import {CsrFiltersStore} from '@/src/features/catalog/filters-v2/view-model/csr-filters.store'
import {TransformFiltersUseCase} from '@/src/core/application/catalog'

const initializeModule = ({bind}: ContainerModuleLoadOptions) => {
  bind<ProductListItemViewModelFactory>(DI.ProductListItemViewModelFactory).toFactory(
    () => productViewModelFactory,
  )
  bind<CatalogProductListViewModelFactory>(DI.CatalogProductListViewModelFactory).toFactory(
    context => (products: Product[]) =>
      new CatalogProductListVM(context.get(DI.ProductListItemViewModelFactory), products),
  )

  bind<TransformFiltersUseCase>(DI.TransformFiltersUseCase).to(TransformFiltersUseCase)

  bind<FiltersViewModelFactory>(DI.FiltersViewModelFactory).toFactory(
    context => filters => new CsrFiltersStore(filters, context.get(DI.TransformFiltersUseCase)),
  )
}

export const CatalogModule = new ContainerModule(initializeModule)
